// extracted by mini-css-extract-plugin
export default {"templateDownloadText":"TemplateDownload_templateDownloadText__V+bO+","activeLink":"TemplateDownload_activeLink__WSuLT","disabledLink":"TemplateDownload_disabledLink__fGiuq"};